module.exports = fox._r("images/valentines/gift-15.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/valentines/gift-15.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/valentines/gift-15.png
// module id = 239
// module chunks = 4